import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import iconSuccess from '../../../icons/circle-status-success.svg';
import iconInProgress from '../../../icons/circle-status-in-progress.svg';
import iconFailure from '../../../icons/circle-status-failure.svg';
import iconNew from '../../../icons/circle-status-new.svg';
import iconProcessing from '../../../icons/circle-status-processing.svg';
import iconToConfirm from '../../../icons/circle-status-to-confirm.svg';
import iconAgreed from '../../../icons/circle-status-agreed.svg';
import iconRejected from '../../../icons/circle-status-rejected.svg';
import iconCanceled from '../../../icons/circle-status-canceled.svg';
import iconSigned from '../../../icons/circle-status-signed.svg';
import iconFinanced from '../../../icons/circle-status-financed.svg';
import iconTerminated from '../../../icons/circle-status-terminated.svg';
import iconPaid from '../../../icons/circle-status-paid.svg';
import iconUncompleted from '../../../icons/circle-status-uncompleted.svg';
import iconAccepted from '../../../icons/circle-status-accepted.svg';
import iconPending from '../../../icons/circle-status-pending.svg';

const statusColors = {
  LOCKED: iconInProgress,
  PROPOSAL_STARTED: iconInProgress,
  PROPOSAL_SUBMITTED: iconInProgress,
  POSITIVE_DECISION: iconInProgress,
  NEGATIVE_DECISION: iconFailure,
  ACCEPTED: iconInProgress,
  NOT_ACCEPTED: iconFailure,
  SIGNED: iconInProgress,
  ACTIVE: iconSuccess,
  new: iconNew,
  processing: iconProcessing,
  to_confirm: iconToConfirm,
  agreed: iconAgreed,
  rejected: iconRejected,
  canceled: iconCanceled,
  signed: iconSigned,
  financed: iconFinanced,
  terminated: iconTerminated,
  paid: iconPaid,
  uncompleted: iconUncompleted,
  accepted: iconAccepted,
  pending: iconPending,
  DECISION_ACCEPTANCE: iconInProgress,
  CONTRACT_ACCEPTED: iconInProgress,
  CONTRACT_SIGNED: iconInProgress,
  CONTRACT_ACTIVE: iconSuccess,
  CONTRACT_TERMINATED: iconFailure,
};

const StatusFormatter = ({ status }) => {
  return (
    <span className='lead-status-cell'>
      <img src={statusColors[status]} alt='' />
      <FormattedMessage id={status} />
    </span>
  );
};

StatusFormatter.propTypes = {
  status: PropTypes.string.isRequired,
};

export default StatusFormatter;
